/* ===== SMOOTH SCROLL ===== */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var targetId = this.getAttribute('href');
      if (targetId === '#') return;
      var target = document.querySelector(targetId);
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('.header');
      var headerHeight = header ? header.offsetHeight : 0;
      var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scrollTo({ top: targetPosition, behavior: 'smooth' });
      // Close mobile nav if open
      var mobileNav = document.querySelector('.header__nav');
      if (mobileNav && mobileNav.classList.contains('is-open')) {
        mobileNav.classList.remove('is-open');
        document.body.classList.remove('no-scroll');
      }
    });
  });

  /* ===== MOBILE NAV TOGGLE ===== */
  var menuToggle = document.querySelector('.header__menu-toggle');
  var nav = document.querySelector('.header__nav');
  var navClose = document.querySelector('.header__nav-close');

  function closeMobileNav() {
    if (nav) nav.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', false);
  }

  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      document.body.classList.toggle('no-scroll', isOpen);
      menuToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  if (navClose) {
    navClose.addEventListener('click', closeMobileNav);
  }

  // Close mobile nav when any nav link is clicked
  document.querySelectorAll('.header__nav-link').forEach(function (link) {
    link.addEventListener('click', closeMobileNav);
  });

  /* ===== STICKY HEADER SHADOW ===== */
  var header = document.querySelector('.header');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 50) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ===== CART COUNT ===== */
  updateCartCount();

  /* ===== DISABLE TRANSITIONS DURING RESIZE ===== */
  var resizeTimer;
  window.addEventListener('resize', function () {
    document.body.classList.add('is-resizing');
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.body.classList.remove('is-resizing');
    }, 150);
  });

  /* ===== SCROLL REVEAL ===== */
  var revealEls = document.querySelectorAll('.reveal');
  if (window.location.hash || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    // Skip animations when navigating to an anchor or reduced motion preferred
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  } else if (revealEls.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { observer.observe(el); });
  }
});

function updateCartCount() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var badges = document.querySelectorAll('.cart-count');
      badges.forEach(function (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    })
    .catch(function () {});
}
